import * as React from 'react';
import {
  Spinner,
  SpinnerSize,
  Stack,
} from '@fluentui/react';

export function LoadingSpinner(): React.ReactElement {
  return (
    <Stack
      style={{ width: '100%', margin: '200px auto 0px auto', display: 'table' }}
    >
      <Spinner
        label="Loading, please wait..." 
        size={SpinnerSize.large} 
        style={{ border: '30px' }} 
      />
    </Stack>
  );
}
